import React from "react";
import { Trans } from "react-i18next";
import Icon, {
  SettingOutlined,
  TeamOutlined,
  ShoppingCartOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { NavigationInterface, OrgType } from "Types/common.types";
import { OrgType as Org } from "Types/common.types";
import { UserRoleToAssign as Role } from "Types/user.types";

const navigation: NavigationInterface[] = [
  {
    label: <Trans>{"nav.deliveryManagement"}</Trans>,
    icon: (
      <Icon
        component={() => (
          <svg viewBox="0 0 1024 1024" width="200" height="200">
            <path
              d="M794.624 366.24A32.032 32.032 0 0 0 768 352h-32a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32v-48c0-6.304-1.888-12.512-5.376-17.76l-96-144zM864 576h-128v-192h32l96 144V576z"
              fill="currentColor"
            ></path>
            <path
              d="M1007.872 490.752l-128-192A95.84 95.84 0 0 0 800 256h-128V192c0-52.928-43.072-96-96-96H96C43.072 96 0 139.072 0 192v352c0 52.928 43.072 96 96 96v96c0 52.928 43.072 96 96 96h36.544c14.304 55.072 64 96 123.488 96 59.424 0 109.12-40.928 123.424-96h169.024c14.304 55.072 64 96 123.488 96 59.424 0 109.12-40.928 123.424-96H928c52.928 0 96-43.072 96-96v-192c0-19.008-5.568-37.44-16.128-53.248zM96 576a32 32 0 0 1-32-32V192a32 32 0 0 1 32-32h480a32 32 0 0 1 32 32v352a32 32 0 0 1-32 32H96z m256.032 288a64 64 0 1 1 0-128 64 64 0 0 1 0 128zM768 864a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m192-128a32 32 0 0 1-32 32h-36.576c-14.304-55.072-64-96-123.424-96-59.488 0-109.184 40.928-123.488 96h-169.024c-14.304-55.072-64-96-123.424-96-59.488 0-109.184 40.928-123.488 96H192a32 32 0 0 1-32-32v-96h416c52.928 0 96-43.072 96-96v-224h128c10.688 0 20.672 5.344 26.624 14.24l128 192c3.488 5.248 5.376 11.456 5.376 17.76v192z"
              fill="currentColor"
            ></path>
          </svg>
        )}
      />
    ),
    href: "/delivery-management",
    isActive: true,
    roles: Object.values(OrgType),
    children: [
      {
        label: <Trans>{"nav.parcelTracking"}</Trans>,
        icon: <ShoppingCartOutlined />,
        href: "/delivery-management/parcel-tracking",
      },
      {
        label: <Trans>{"nav.reporting"}</Trans>,
        icon: <ShoppingCartOutlined />,
        href: "/delivery-management/report",
      },
      {
        label: <Trans>{"nav.controlTower"}</Trans>,
        href: "/delivery-management/control-tower",
        exclude: [`${Org.CUSTOMER}-${Role.OPERATIONAL_STAFF}`,]
      },
    ],
  },
  {
    label: <Trans>{"nav.orderProcessing"}</Trans>,
    icon: <ShoppingCartOutlined />,
    href: "/parcels-order-processing",
    isActive: true,
    roles: Object.values(OrgType),
    exclude: [Role.PUBLIC_TRANSPORT_OPERATIONAL_USER],
    children: [
      {
        label: <Trans>{"nav.shipments"}</Trans>,
        icon: <ShoppingCartOutlined />,
        href: "/parcels-order-processing/parcels",
      },
      {
        label: <Trans>{"nav.planSchedule"}</Trans>,
        href: "/order-management/plan-schedule",
        exclude: [`${Org.CUSTOMER}-${Role.OPERATIONAL_STAFF}`,]
      },
      {
        label: <Trans>{"nav.allOrders"}</Trans>,
        href: "/order-management/all",
      },
      {
        label: <Trans>{"nav.reporting"}</Trans>,
        href: "/parcels-order-processing/reporting",
      },
    ],
  },
  {
    label: <Trans>{"nav.customerManagement"}</Trans>,
    icon: (
      <Icon
        component={() => (
          <Icon
            component={() => (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_41_3529"
                  maskUnits="userSpaceOnUse"
                  x="2"
                  y="4"
                  width="20"
                  height="16"
                >
                  <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.00007 6H19.0001C19.5501 6 20.0001 5.55 20.0001 5C20.0001 4.45 19.5501 4 19.0001 4H5.00007C4.45007 4 4.00007 4.45 4.00007 5C4.00007 5.55 4.45007 6 5.00007 6ZM20.1601 7.8C20.0701 7.34 19.6601 7 19.1801 7H4.82007C4.34007 7 3.93007 7.34 3.84007 7.8L2.84007 12.8C2.72007 13.42 3.19007 14 3.82007 14H4.00007V19C4.00007 19.55 4.45007 20 5.00007 20H13.0001C13.5501 20 14.0001 19.55 14.0001 19V14H18.0001V19C18.0001 19.55 18.4501 20 19.0001 20C19.5501 20 20.0001 19.55 20.0001 19V14H20.1801C20.8101 14 21.2801 13.42 21.1601 12.8L20.1601 7.8ZM6.00007 18H12.0001V14H6.00007V18Z"
                  />
                </mask>
                <g mask="url(#mask0_41_3529)">
                  <rect width="24" height="24" fill="#ffffff" />
                </g>
              </svg>
            )}
          />
        )}
      />
    ),
    href: "/customer-management/list",
    isActive: true,
    roles: [
      OrgType.OWNER,
      OrgType.LP,
      `${Org.CUSTOMER}-${Role.SUPER_ADMIN}`,
      `${Org.COMPANY}-${Role.SUPER_ADMIN}`,
      `${Org.COMPANY}-${Role.OPERATIONAL_STAFF}`,
      `${Org.CUSTOMER}-${Role.OPERATIONAL_STAFF}`,
    ],
    children: [
      {
        label: <Trans>{"nav.customerProfile"}</Trans>,
        icon: (
          <Icon
            component={() => (
              <svg
                fill="currentColor"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="10461"
              >
                <path
                  d="M960 960h-97.664V461.568L512 192.128l-350.336 269.44V960H64V408.512L512 64l448 344.512V960"
                  p-id="10462"
                ></path>
                <path
                  d="M256 960h192v-192H256zM256 704h192V512H256zM512 960h192v-192H512z"
                  p-id="10463"
                ></path>
              </svg>
            )}
          />
        ),
        href: "/customer-management/profile",
        exclude: [Org.CUSTOMER],
      },
      {
        label: <Trans>{"nav.deletedCustomerProfile"}</Trans>,
        icon: (
          <Icon
            component={() => (
              <svg
                fill="currentColor"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="10461"
              >
                <path
                  d="M960 960h-97.664V461.568L512 192.128l-350.336 269.44V960H64V408.512L512 64l448 344.512V960"
                  p-id="10462"
                ></path>
                <path
                  d="M256 960h192v-192H256zM256 704h192V512H256zM512 960h192v-192H512z"
                  p-id="10463"
                ></path>
              </svg>
            )}
          />
        ),
        href: "/customer-management/profile/deleted",
        exclude: [Org.CUSTOMER],
      },
      {
        label: <Trans>{"nav.customerLocation"}</Trans>,
        icon: (
          <Icon
            component={() => (
              <svg
                fill="currentColor"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="10461"
              >
                <path
                  d="M960 960h-97.664V461.568L512 192.128l-350.336 269.44V960H64V408.512L512 64l448 344.512V960"
                  p-id="10462"
                ></path>
                <path
                  d="M256 960h192v-192H256zM256 704h192V512H256zM512 960h192v-192H512z"
                  p-id="10463"
                ></path>
              </svg>
            )}
          />
        ),
        href: "/customer-management/location",
      },
      {
        label: <Trans>{"nav.deletedCustomerLocation"}</Trans>,
        icon: (
          <Icon
            component={() => (
              <svg
                fill="currentColor"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="10461"
              >
                <path
                  d="M960 960h-97.664V461.568L512 192.128l-350.336 269.44V960H64V408.512L512 64l448 344.512V960"
                  p-id="10462"
                ></path>
                <path
                  d="M256 960h192v-192H256zM256 704h192V512H256zM512 960h192v-192H512z"
                  p-id="10463"
                ></path>
              </svg>
            )}
          />
        ),
        href: "/customer-management/location/deleted",
        exclude: [`${Org.CUSTOMER}-${Role.OPERATIONAL_STAFF}`],
      },
    ],
  },
  {
    label: <Trans>{"nav.driverManagement"}</Trans>,
    icon: (
      <Icon
        component={() => (
          <Icon
            component={() => (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_694_5090"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="5"
                  width="24"
                  height="14"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.44 9.03L17.31 6.9L15.71 5.3C15.52 5.11 15.26 5 15 5H12C11.45 5 11 5.45 11 6C11 6.55 11.45 7 12 7H14.59L16.59 9H5C2.2 9 0 11.2 0 14C0 16.8 2.2 19 5 19C7.46 19 9.45 17.31 9.9 15H10.72C11.25 15 11.76 14.79 12.13 14.41L14.31 12.23C14.11 12.77 14 13.37 14 14C14 16.8 16.2 19 19 19C21.8 19 24 16.8 24 14C24 11.35 22.03 9.23 19.44 9.03ZM5 15H7.82C7.4 16.15 6.28 17 5 17C3.37 17 2 15.63 2 14C2 12.37 3.37 11 5 11C6.28 11 7.4 11.85 7.82 13H5C4.45 13 4 13.45 4 14C4 14.55 4.45 15 5 15ZM16 14C16 15.66 17.34 17 19 17C20.66 17 22 15.66 22 14C22 12.34 20.66 11 19 11C17.34 11 16 12.34 16 14Z"
                    fill="#ffffff"
                  />
                </mask>
                <g mask="url(#mask0_694_5090)">
                  <rect width="24" height="24" fill="#ffffff" />
                </g>
              </svg>
            )}
          />
        )}
      />
    ),
    href: "/driver-management",
    isActive: true,
    roles: [Org.LP, Org.COMPANY, Org.OWNER, `${Org.CUSTOMER}-${Role.ADMIN}`,],
    exclude: [Role.PUBLIC_TRANSPORT_OPERATIONAL_USER],
    children: [
      {
        label: <Trans>{"nav.driver"}</Trans>,
        icon: (
          <Icon
            component={() => (
              <svg
                fill="currentColor"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="10461"
              >
                <path
                  d="M960 960h-97.664V461.568L512 192.128l-350.336 269.44V960H64V408.512L512 64l448 344.512V960"
                  p-id="10462"
                ></path>
                <path
                  d="M256 960h192v-192H256zM256 704h192V512H256zM512 960h192v-192H512z"
                  p-id="10463"
                ></path>
              </svg>
            )}
          />
        ),
        href: "/driver-management/driver",
      },
      {
        label: <Trans>{"nav.deactivatedDriver"}</Trans>,
        icon: (
          <Icon
            component={() => (
              <svg
                fill="currentColor"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="10461"
              >
                <path
                  d="M960 960h-97.664V461.568L512 192.128l-350.336 269.44V960H64V408.512L512 64l448 344.512V960"
                  p-id="10462"
                ></path>
                <path
                  d="M256 960h192v-192H256zM256 704h192V512H256zM512 960h192v-192H512z"
                  p-id="10463"
                ></path>
              </svg>
            )}
          />
        ),
        href: "/driver-management/driver/deleted",
      },
    ],
  },
  {
    label: <Trans>{"nav.userManagement"}</Trans>,
    icon: <TeamOutlined />,
    href: "/user-management",
    isActive: true,
    roles: Object.values(OrgType),
    exclude: [
      Role.PUBLIC_TRANSPORT_OPERATIONAL_USER,
      Role.ADMIN,
      Role.OPERATION_SUPERVISOR,
      `${Org.CUSTOMER}-${Role.OPERATIONAL_STAFF}`
    ],
    children: [
      {
        label: <Trans>{"nav.users"}</Trans>,
        href: "/user-management/users",
      },
      {
        label: <Trans>{"nav.inactiveUsers"}</Trans>,
        href: "/user-management/users/inactive",
        includeOnly: Role.SUPER_ADMIN,
      },
    ],
  },
  {
    label: <Trans>{"nav.incidentReports"}</Trans>,
    icon: <ExclamationCircleFilled />,
    href: "/incident-reports/report",
    isActive: true,
    roles: [Org.COMPANY, Role.ADMIN],
  },
  {
    label: <Trans>{"nav.settings"}</Trans>,
    icon: <SettingOutlined />,
    href: "",
    isActive: true,
    roles: [Org.COMPANY],
    includeOnly: Role.SUPER_ADMIN,
    children: [
      {
        label: <Trans>{"nav.orderProcessing"}</Trans>,
        href: "/order-management/settings",
      },
      {
        label: <Trans>{"nav.setup"}</Trans>,
        href: "/delivery-management/settings/assets",
      },
      {
        label: <Trans>{"nav.accessPoints"}</Trans>,
        href: "/delivery-management/settings/service-points",
      },
      {
        label: <Trans>{"nav.lines"}</Trans>,
        href: "/delivery-management/settings/lines",
      },
    ],
  },
];

export default navigation;
